<template>
  <div class="c-advances-declines">
    <div class="c-advances-declines__label" v-if="label && !hideLabel">{{ label }}</div>
    <div class="c-advances-declines__chart">
      <span class="c-advances-declines__chart--advances" :style="{ width: normalizedAdvances + '%' }" />
      <span class="c-advances-declines__chart--neutral" :style="{ width: neutral + '%' }" />
      <span class="c-advances-declines__chart--declines" :style="{ width: normalizedDeclines + '%' }" />
    </div>
    <div class="c-advances-declines__legend" v-if="!hideLegend">
      <span class="c-advances-declines__legend--advances"
        ><span class="sr-only">Total Advances</span>{{ totalAdvances }}</span
      >
      <span class="c-advances-declines__legend--neutral"
        ><span class="sr-only">Total Neutral</span>{{ totalNeutral }}</span
      >
      <span class="c-advances-declines__legend--declines"
        ><span class="sr-only">Total Declines</span>{{ totalDeclines }}</span
      >
      <span class="c-advances-declines__legend--advances"
        ><span class="sr-only">Advances</span>({{ normalizedAdvances }}%</span
      >
      <span class="c-advances-declines__legend--neutral"><span class="sr-only">Neutral</span>{{ neutral }}%</span>
      <span class="c-advances-declines__legend--declines"
        ><span class="sr-only">Declines</span>{{ normalizedDeclines }}%)</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'c-advances-declines',
  props: {
    label: {
      type: String,
      default: 'Advances/Declines'
    },
    advances: {
      type: Number
    },
    declines: {
      type: Number
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    hideLegend: {
      type: Boolean,
      default: false
    },
    totalAdvances: {
      type: Number,
      default: 0
    },
    totalNeutral: {
      type: Number,
      default: 0
    },
    totalDeclines: {
      type: Number,
      default: 0
    }
  },
  computed: {
    normalizedAdvances() {
      return Math.floor(this.advances * 10) / 10;
    },
    normalizedDeclines() {
      return Math.floor(this.declines * 10) / 10;
    },
    neutral() {
      const val = 100 - this.normalizedAdvances - this.normalizedDeclines;
      return Math.floor(val * 10) / 10;
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/components/custom/c-advances-declines';
</style>
